import React from 'react'
import {Flex, Text} from '../../../vanilla'
import {useIntl} from 'react-intl'
import {observer} from 'mobx-react-lite'
import {Promotion} from '../../../store/ProductStore'
import {useGlobalStore} from '../../../store/hooks/useStore'
import {MultibuyBadgeIcon} from '../../icons'
import Separator from './separator'

interface MultibuyPromoBadgeProps {
  promotion: Promotion
}

export const MultibuyPromoBadge = observer((props: MultibuyPromoBadgeProps) => {
  const {promotion} = props
  const {formatNumber} = useIntl()
  const {currency} = useGlobalStore()
  const unitPrice = Number(promotion?.multibuyUnitPrice)

  if (Number.isNaN(unitPrice)) {
    return null
  }

  const price = unitPrice < 1
    ? `${(unitPrice * 100).toFixed(0)}p`
    : formatNumber(unitPrice, {style: 'currency', currency})

  return (
    <>
      <Separator />
      <Flex
        direction="column"
        paddingRight="4px"
        paddingBottom="4px"
        paddingLeft="36px"
        style={{
          width: 150,
          backgroundColor: '#FFEA00',
          borderRadius: '4px',
          paddingTop: '1px',
          position: 'relative',
          gap: '5px'
        }}
        align="center"
      >
        <MultibuyBadgeIcon
          boxSize="32px"
          style={{
            position: 'absolute',
            left: '2px',
            top: '-2px'
          }}
        />

        {/* Multibuy Text */}
        <Flex gap="4px" align="flex-end">
          <Text as="span" variant="text0" color="black" lineHeight="none" marginBottom="2px">
            from
          </Text>

          <Text as="span" variant="heading1Bold" color="black" lineHeight="none">
            {price}
          </Text>

          <Text as="span" variant="text0" color="black" lineHeight="none" marginBottom="2px">
            each
          </Text>
        </Flex>

        {/* Unit Pricing Text */}
        {promotion?.unitPriceMsg && (
          <Text
            variant="unstyled"
            style={{fontSize: '12px', fontWeight: '400', lineHeight: '11px'}}
            textAlign="center"
          >
            {promotion.unitPriceMsg}
          </Text>
        )}
      </Flex>
    </>
  )
})
